import React, { useState, useEffect } from 'react';
import Button from '@sabre/spark-react-core/button';
import { func, array, string } from 'prop-types';
import {
   URL_CORE_PRICING_DELETE_DISTRIBUTION,
   URL_CORE_PRICING_MARKET_LIST_DELETE,
   URL_CORE_PRICING_WORKING_FARES,
} from '../../../end-points.js';
import { useDelete } from '../../../hooks/use-delete.js';
import { API_STATUS, SCREEN_NAMES } from '../../../utils/constants.js';
import { NOTIFICATION_MESSAGES } from '../../../utils/notification-messages.js';
import { toastWarn } from '../../../utils/toasts.js';

const DistributionDeleteConfirmation = ({
   onCancelButtonClick,
   distributionListToDelete,
   onUpdateDistributionTable,
   selectedScreen,
}) => {
   const { deleteStatus, deleteChanges } = useDelete({});
   const [isDelete, setIsDelete] = useState(false);
   useEffect(() => {
      if (deleteStatus === API_STATUS.COMPLETED && isDelete) {
         let updatedData = null;
         if (selectedScreen === SCREEN_NAMES.FARES) {
            updatedData = distributionListToDelete.distributionGroupNumber.workingFares;
         } else if (selectedScreen === SCREEN_NAMES.MARKET_LIST) {
            updatedData = distributionListToDelete;
         }
          else if (selectedScreen ===  SCREEN_NAMES.REFERENCE) {
            updatedData = distributionListToDelete.dgNumber;
         }
         onUpdateDistributionTable(updatedData);
      } else if (deleteStatus === API_STATUS.FAILED) {
         toastWarn(NOTIFICATION_MESSAGES.FAILED_TO_DELETE);
      }
   }, [deleteStatus]);
   const parsingObject = (data) => {
      delete data.screen;
      return data;
   };
   const handleDeleteConformationButtonClick = () => {
      setIsDelete(true);
      let deleteUrl = null;
      if(selectedScreen === SCREEN_NAMES.FARES)
         deleteUrl = URL_CORE_PRICING_WORKING_FARES;
      else if(selectedScreen === SCREEN_NAMES.MARKET_LIST)
         deleteUrl = URL_CORE_PRICING_MARKET_LIST_DELETE
      else
      deleteUrl = URL_CORE_PRICING_DELETE_DISTRIBUTION
      deleteChanges(
         parsingObject(
            selectedScreen === 'Fares'
               ? distributionListToDelete.distributionGroupNumber
               : distributionListToDelete
         ),
         deleteUrl
      );
   };
   return (
      <div className='distribution-delete-conformation-root'>
         <div className='row spark-bold delete-conform-text'>{`  ${
            selectedScreen === 'Reference'
               ? 'Are you sure you want to delete these rows and all data within them ?'
               : 'All data within them ?'
         }`}</div>
         <div className='row spark-flex spark-pad-t-2 alignment-right'>
            <Button
               name='dg-cancel-button'
               className='spark-btn--secondary spark-mar-r-1'
               size={Button.SIZE.SMALL}
               onClick={onCancelButtonClick}
            >
               CANCEL
            </Button>
            <Button
               name='dg-upload-button'
               className='spark-btn--primary'
               size={Button.SIZE.SMALL}
               onClick={handleDeleteConformationButtonClick}
            >
               Delete
            </Button>
         </div>
      </div>
   );
};
DistributionDeleteConfirmation.propTypes = {
   distributionListToDelete: array,
   onCancelButtonClick: func,
   onUpdateDistributionTable: func,
   selectedScreen: string,
};
export default DistributionDeleteConfirmation;
